import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import {default as Annotation} from 'chartjs-plugin-annotation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { SyncConfigService } from '../../../../../core/services/sync-config.service';
import { JobsService } from '../../../../../core/services/jobs.service';
import { SyncChartData } from '../../../../../core/models/charts';

@Component({
  selector: 'app-job-chart-dialog',
  templateUrl: './job-chart-dialog.component.html',
  styleUrls: ['./job-chart-dialog.component.scss']
})
export class JobChartDialogComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<JobChartDialogComponent>,
    private syncConfig: SyncConfigService,
    public jobService: JobsService,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; jobName: string; path: string; vmNodeName: string; id: string; depId: string }  ) {
    Chart.register(Annotation)
  }

  public lineChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: []
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      x: {
        type: 'linear',
        position: 'bottom',
        grid: {
          color: 'red',
        },
        ticks: {
          color: '#0072c6'
        }
      },
      y:
      {
        position: 'left',
        grid: {
          color: '#0072c6',
        },
        ticks: {
          color: 'red'
        }
      }
    },
    plugins: {
      legend: { display: true },
      //annotation: {
      //  annotations: [
      //    {
      //      type: 'line',
      //      scaleID: 'x',
      //      value: 'March',
      //      borderColor: 'orange',
      //      borderWidth: 2,
      //      label: {
      //        position: 'center',
      //        enabled: true,
      //        color: 'orange',
      //        content: 'LineAnno',
      //        font: {
      //          weight: 'bold'
      //        }
      //      }
      //    },
      //  ],
      //}
    }
  };

  public lineChartType: ChartType = 'line';
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  toogleDialog: boolean = false;
  trimIndex: number = 50;
  toogleFullScreen: boolean = false;
  dataCheckSubs: Subscription;

  ngOnInit(): void {
  }

  loadGraphData() {
    this.jobService
      .viewGraphOutput(
        this.data.depName,
        this.data.jobName
    ).subscribe({
        next: (data) => {
        let response = <SyncChartData>JSON.parse(JSON.stringify(data))
        response.graphData.forEach((gD, i) => {
          let ds = this.lineChartData.datasets.filter(s => s.label == gD.name);
          if (ds.length > 0) {
            ds[0].data = gD.data.map(x => x.x);
            this.lineChartData.labels = gD.data.map(y => y.y);
          }
          else {
            this.lineChartData.datasets.push({
              data: gD.data,
              label: gD.name
            });
            this.lineChartData.labels.push(...gD.data.map(y => y.y))
          }
        });
        this.chart.update();
        }, error: (error) => {
        }
      })
  }

  ngAfterViewInit() {
    this.dataCheckSubs = interval(this.syncConfig.config.jobs.outputReqInterval).subscribe(() => {
      this.loadGraphData();
    });
  }

  onCancel() {
    this.dialog.close();
    if (this.dataCheckSubs) this.dataCheckSubs.unsubscribe();
  }

  toogleDialogMinMax() {
    if (this.toogleFullScreen && !this.toogleDialog) { this.onFullScreen() }
    if (this.toogleDialog == false) {
      this.toogleDialog = true;
      let element = document.getElementById(this.data.id);
      element.classList.add('minimize2')
      this.trimIndex = 25
    } else {
      this.toogleDialog = false;
      let element = document.getElementById(this.data.id);
      element.classList.remove('minimize2')
      this.trimIndex = 50
    }
  }

  onFullScreen() {
    if (this.toogleDialog) { this.toogleDialogMinMax() }
    let element = document.querySelector('.custom-output-dialog-container');
    if (!this.toogleFullScreen) {
      element.classList.add('fullScreen');
    } else {
      element.classList.remove('fullScreen');
    }
    this.toogleFullScreen = !this.toogleFullScreen;
  }
}
